// import React from "react";

// const Homepage_Poster = ({ images }) => {
//   // Check if images is properly passed and is an array
//   if (!Array.isArray(images)) {
//     console.error('Expected "images" to be an array, but got:', images);
//     return <p>No images available</p>; // Provide a fallback UI
//   }

//   // Calculate the column size based on the number of images
//   const columnSize = 12 / images.length;
//   return (
//     <div className="container-md-fluid m-6 container" style={{ padding: '20px' }}>
//       <div className="row">
//         {images.map((image, index) => (
//           <div key={index} className={`col-${Math.floor(columnSize)} px-6`}>
//             <img src={image.src} alt={image.title} className="img-fluid" style={{borderRadius:'10px'}} />
           
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Homepage_Poster;


import React, { useEffect, useState } from 'react';
import './Homepage_Poster.css';

function Homepage_Poster({images}) {
  // const [images, setImages] = useState([
  //   './3rd-Banner-1065456-3.png',
  //   './3rd-Banner-1065456-3.png',
  // ]);

  // // Simulating an async fetchImages function
  // async function fetchImages() {
  //   // Simulate fetching images from an API or server
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve([
  //         './3rd-Banner-1065456-3.png',
  //         './3rd-Banner-1065456-3.png',
  //       ]);
  //     }, 1000);
  //   });
  // }

  // useEffect(() => {
  //   async function fetch() {
  //     const fetchedImages = await fetchImages(); // Wait for the promise to resolve
  //     setImages(fetchedImages); // Update state with the resolved images
  //   }

  //   fetch(); // Call the async function
  // }, []);

  return (
    <div className="Homepage-poster-container">
      {images.map((image, index) => (
        <img key={index} src={image} alt={`Poster ${index + 1}`} />
      ))}
    </div>
  );
}

export default Homepage_Poster;
